<template>
  <div class="l-role-box">
    <div class="l-container-title">
      <i class="ri-organization-chart"></i><b>组织架构</b>
      <l-auth-text-button auth="applet_org_admin_create" type="primary" style="float: right; font-size: 14px" @click="showAdd(1)"> <i class="el-icon-plus" style="font-size: 14px" />创建 </l-auth-text-button>
    </div>

    <div class="l-role-list-main" v-loading="loading">
      <el-tree ref="tree" :data="tree_data" node-key="id" default-expand-all highlight-current :expand-on-click-node="false" :current-node-key="select_id" @node-click="handleNodeClick">
        <div class="custom-tree-node" slot-scope="{ node, data }" @click="checkOrg(data.id)" @mouseover="show_action_id = data.id" @mouseleave="show_action_id = ''" style="width: 100%">
          <span :class="{ 'l-elipsis': select_id == data.id || show_action_id == data.id }">
            <i class="ri-building-2-fill" style="color: #409eff; font-size: 17px" v-show="data.type == 1"></i>
            <i class="ri-team-fill" style="color: #e6a23c; font-size: 17px" v-show="data.type == 2"></i>
            {{ node.label }}
          </span>
          <span style="float: right" v-show="select_id == data.id || show_action_id == data.id">
            <l-auth-text-button auth="applet_org_add_btn" type="primary" @click.stop="showAdd(data.id)">
              <i class="el-icon-plus"></i>
            </l-auth-text-button>
            <l-auth-text-button auth="applet_org_edit_btn" type="primary" @click.stop="showEdit(data.id)" v-if="data.can_edit">
              <i class="el-icon-edit"></i>
            </l-auth-text-button>
            <l-auth-text-button auth="applet_org_del_btn" type="danger" @click.stop="del(data.id)" v-if="data.can_edit">
              <i class="el-icon-delete"></i>
            </l-auth-text-button>
          </span>
        </div>
      </el-tree>
    </div>

    <!--添加角色弹窗-->
    <l-dialog :visible.sync="add_visible" title="创建组织" width="500px">
      <l-applet-org-edit @on-success="onAddSuccess" :visible.sync="add_visible" :pid="pid" />
    </l-dialog>

    <l-dialog :visible.sync="edit_visible" title="编辑组织" width="500px">
      <l-applet-org-edit @on-success="onEditSuccess" :visible.sync="edit_visible" :id="edit_id" />
    </l-dialog>

    <!--编辑角色弹窗-->
    <!-- <l-dialog :visible.sync="show_edit" title="编辑角色" width="500px">
      <l-department-edit @on-success="onEditSuccess" :visible.sync="show_edit" :id="edit_id" />
    </l-dialog> -->
  </div>
</template>
<script>
import Edit from "./Edit";
export default {
  name: "l-applet-org-list",
  components: {
    [Edit.name]: Edit,
  },
  data() {
    return {
      loading: false,

      tree_data: [],
      select_id: null,
      show_action_id: null,

      add_visible: false,
      pid: "",

      edit_visible: false,
      edit_id: "",
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    //获取组织架构数据
    getList() {
      this.loading = true;
      this.$_invoke("uniOrg_getTree")
        .then((ret) => {
          this.tree_data = ret.tree_data;
          //如果未选中角色，则进行选中
          if (!this.select_id) {
            if (this.tree_data.length > 0) {
              this.checkOrg(this.tree_data[0].id);
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //显示添加组织架构弹窗
    showAdd(pid) {
      this.pid = pid;
      this.add_visible = true;
    },

    //选中某个组织
    checkOrg(id) {
      //点击角色前的前置事件
      this.$emit("on-before-check");
      this.$nextTick(() => {
        this.select_id = id;
        this.$refs.tree.setCurrentKey(id);
        this.$emit("on-after-check", id);
      });
    },

    //添加成功回调
    onAddSuccess() {
      this.pid = "";
      this.add_visible = false;
      this.getList();
    },

    //显示编辑
    showEdit(id) {
      this.edit_id = id;
      this.edit_visible = true;
    },

    //编辑成功回调
    onEditSuccess() {
      this.edit_id = "";
      this.edit_visible = false;
      this.getList();
    },

    //删除
    del(id) {
      this.$confirm("确认删除该组织吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke("uniOrg_delete", { id }).then(() => {
            this.$_msg.success("删除成功");
            this.getList();
          });
        })
        .catch(() => {});
    },

    //点击节点
    handleNodeClick(data) {
      this.checkOrg(data.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.l-elipsis {
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
}
</style>
